import { IconButton, SvgAdd, SvgTrash } from '@loomhq/lens';
import classNames from 'classnames';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateTextBlocks } from 'actions/textOverlay';
import { requestVideoPlayerPause } from 'actions/videoPlayer';
import { ROLLOUT_TEXT_TO_SPEECH } from 'constants/featureFlag';
import { selectVideoId } from 'selectors/video';
import {
  selectCurrentUserIsOwner,
  selectHasStarted,
  selectPlayerTime,
} from 'selectors/videoPlayer';
import { sendTextBlocksUpdate } from 'utilities/text-overlay';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import styles from './styles.module.less';

const TextToSpeechControlsWrapper = () => {
  const text2SpeechVisible = useSelector(state => state.textOverlay.show);
  const isVideoOwner = useSelector(selectCurrentUserIsOwner);
  const setTextOverlayEnabled = useFeatureFlagValue(ROLLOUT_TEXT_TO_SPEECH);
  const videoHasStarted = useSelector(selectHasStarted);

  if (
    !text2SpeechVisible ||
    !isVideoOwner ||
    !setTextOverlayEnabled ||
    !videoHasStarted
  ) {
    return null;
  }

  return <TextToSpeechControls />;
};

const TextToSpeechControls = () => {
  const dispatch = useDispatch();

  const textBlocks = useSelector(state => state.textOverlay.textBlocks);
  const videoId = useSelector(selectVideoId);

  const playTime = useSelector(selectPlayerTime);

  const hasItemSelected = textBlocks.some(block => block.selected);

  const itemExistsAtCurrentPlaytime = textBlocks.some(
    ({ startTs, endTs }) => playTime >= startTs && playTime <= endTs
  );

  const addTextBlock = () => {
    const newBlock = {
      editing: false,
      selected: true,
      text: 'Text',
      left: 0,
      top: 0,
      width: 300,
      startTs: playTime,
      endTs: playTime + 3,
    };

    dispatch(requestVideoPlayerPause());

    const blocksDeselected = textBlocks.map(block => {
      return {
        ...block,
        selected: false,
      };
    });

    dispatch(updateTextBlocks([...blocksDeselected, newBlock]));
  };

  const removeTextBlock = useCallback(() => {
    const updatedBlocks = textBlocks.filter(block => !block.selected);

    dispatch(updateTextBlocks(updatedBlocks));
    sendTextBlocksUpdate(videoId, updatedBlocks);
  }, [textBlocks, videoId, dispatch]);

  return (
    <div className={classNames('t2s-menu-items', styles.container)}>
      <IconButton
        className="t2s-menu-items"
        onClick={addTextBlock}
        icon={<SvgAdd />}
        iconColor={itemExistsAtCurrentPlaytime ? 'disabledContent' : 'grey8'}
        disabled={itemExistsAtCurrentPlaytime}
      />
      <IconButton
        className="t2s-menu-items"
        onClick={removeTextBlock}
        disabled={!hasItemSelected}
        iconColor={hasItemSelected ? 'grey8' : 'disabledContent'}
        icon={<SvgTrash />}
      />
    </div>
  );
};

export default TextToSpeechControlsWrapper;
